// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRenewalPlanLiteDto } from './IRenewalPlanLiteDto';
import {
    IRenewalPlanLiteDtoFromJSON,
    IRenewalPlanLiteDtoFromJSONTyped,
    IRenewalPlanLiteDtoToJSON,
    IRenewalPlanLiteDtoToJSONTyped,
} from './IRenewalPlanLiteDto';
import type { IRenewalPayrollGroupReducedDto } from './IRenewalPayrollGroupReducedDto';
import {
    IRenewalPayrollGroupReducedDtoFromJSON,
    IRenewalPayrollGroupReducedDtoFromJSONTyped,
    IRenewalPayrollGroupReducedDtoToJSON,
    IRenewalPayrollGroupReducedDtoToJSONTyped,
} from './IRenewalPayrollGroupReducedDto';
import type { IRenewalPayrollCalendarScheduleConfigDto } from './IRenewalPayrollCalendarScheduleConfigDto';
import {
    IRenewalPayrollCalendarScheduleConfigDtoFromJSON,
    IRenewalPayrollCalendarScheduleConfigDtoFromJSONTyped,
    IRenewalPayrollCalendarScheduleConfigDtoToJSON,
    IRenewalPayrollCalendarScheduleConfigDtoToJSONTyped,
} from './IRenewalPayrollCalendarScheduleConfigDto';

/**
 * 
 * @export
 * @interface IRenewalPayrollCalendarDto
 */
export interface IRenewalPayrollCalendarDto {
    /**
     * 
     * @type {number}
     * @memberof IRenewalPayrollCalendarDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPayrollCalendarDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPayrollCalendarDto
     */
    frequency_type?: IRenewalPayrollCalendarDtoFrequencyTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IRenewalPayrollCalendarDto
     */
    created_at?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IRenewalPayrollCalendarDto
     */
    start_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IRenewalPayrollCalendarDto
     */
    end_date?: Date;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPayrollCalendarDto
     */
    status?: IRenewalPayrollCalendarDtoStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IRenewalPayrollCalendarDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPayrollCalendarDto
     */
    organization_path?: string;
    /**
     * 
     * @type {Date}
     * @memberof IRenewalPayrollCalendarDto
     */
    next_autoprolong_at?: Date;
    /**
     * 
     * @type {IRenewalPayrollCalendarScheduleConfigDto}
     * @memberof IRenewalPayrollCalendarDto
     */
    config?: IRenewalPayrollCalendarScheduleConfigDto;
    /**
     * 
     * @type {string}
     * @memberof IRenewalPayrollCalendarDto
     */
    group_type?: IRenewalPayrollCalendarDtoGroupTypeEnum;
    /**
     * 
     * @type {Array<Date>}
     * @memberof IRenewalPayrollCalendarDto
     */
    schedule?: Array<Date>;
    /**
     * 
     * @type {Set<IRenewalPlanLiteDto>}
     * @memberof IRenewalPayrollCalendarDto
     */
    calendar_plans?: Set<IRenewalPlanLiteDto>;
    /**
     * 
     * @type {Set<IRenewalPlanLiteDto>}
     * @memberof IRenewalPayrollCalendarDto
     */
    non_calendar_plans?: Set<IRenewalPlanLiteDto>;
    /**
     * 
     * @type {Set<IRenewalPayrollGroupReducedDto>}
     * @memberof IRenewalPayrollCalendarDto
     */
    calendar_payroll_groups?: Set<IRenewalPayrollGroupReducedDto>;
    /**
     * 
     * @type {Set<IRenewalPayrollGroupReducedDto>}
     * @memberof IRenewalPayrollCalendarDto
     */
    non_calendar_payroll_groups?: Set<IRenewalPayrollGroupReducedDto>;
}

/**
* @export
* @enum {string}
*/
export enum IRenewalPayrollCalendarDtoFrequencyTypeEnum {
    WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    SEMI_MONTHLY = 'SEMI_MONTHLY',
    ANNUALLY = 'ANNUALLY'
}
/**
* @export
* @enum {string}
*/
export enum IRenewalPayrollCalendarDtoStatusEnum {
    ACTIVE = 'ACTIVE',
    DEACTIVATED = 'DEACTIVATED'
}
/**
* @export
* @enum {string}
*/
export enum IRenewalPayrollCalendarDtoGroupTypeEnum {
    ALL = 'ALL',
    GROUP = 'GROUP',
    PLAN = 'PLAN'
}


/**
 * Check if a given object implements the IRenewalPayrollCalendarDto interface.
 */
export function instanceOfIRenewalPayrollCalendarDto(value: object): value is IRenewalPayrollCalendarDto {
    return true;
}

export function IRenewalPayrollCalendarDtoFromJSON(json: any): IRenewalPayrollCalendarDto {
    return IRenewalPayrollCalendarDtoFromJSONTyped(json, false);
}

export function IRenewalPayrollCalendarDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IRenewalPayrollCalendarDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'frequency_type': json['frequency_type'] == null ? undefined : json['frequency_type'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'start_date': json['start_date'] == null ? undefined : (new Date(json['start_date'])),
        'end_date': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
        'status': json['status'] == null ? undefined : json['status'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
        'next_autoprolong_at': json['next_autoprolong_at'] == null ? undefined : (new Date(json['next_autoprolong_at'])),
        'config': json['config'] == null ? undefined : IRenewalPayrollCalendarScheduleConfigDtoFromJSON(json['config']),
        'group_type': json['group_type'] == null ? undefined : json['group_type'],
        'schedule': json['schedule'] == null ? undefined : json['schedule'],
        'calendar_plans': json['calendar_plans'] == null ? undefined : (new Set((json['calendar_plans'] as Array<any>).map(IRenewalPlanLiteDtoFromJSON))),
        'non_calendar_plans': json['non_calendar_plans'] == null ? undefined : (new Set((json['non_calendar_plans'] as Array<any>).map(IRenewalPlanLiteDtoFromJSON))),
        'calendar_payroll_groups': json['calendar_payroll_groups'] == null ? undefined : (new Set((json['calendar_payroll_groups'] as Array<any>).map(IRenewalPayrollGroupReducedDtoFromJSON))),
        'non_calendar_payroll_groups': json['non_calendar_payroll_groups'] == null ? undefined : (new Set((json['non_calendar_payroll_groups'] as Array<any>).map(IRenewalPayrollGroupReducedDtoFromJSON))),
    };
}

export function IRenewalPayrollCalendarDtoToJSON(json: any): IRenewalPayrollCalendarDto {
    return IRenewalPayrollCalendarDtoToJSONTyped(json, false);
}

export function IRenewalPayrollCalendarDtoToJSONTyped(value?: IRenewalPayrollCalendarDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'frequency_type': value['frequency_type'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
        'start_date': value['start_date'] == null ? undefined : ((value['start_date']).toISOString()),
        'end_date': value['end_date'] == null ? undefined : ((value['end_date']).toISOString()),
        'status': value['status'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
        'next_autoprolong_at': value['next_autoprolong_at'] == null ? undefined : ((value['next_autoprolong_at']).toISOString()),
        'config': IRenewalPayrollCalendarScheduleConfigDtoToJSON(value['config']),
        'group_type': value['group_type'],
        'schedule': value['schedule'],
        'calendar_plans': value['calendar_plans'] == null ? undefined : (Array.from(value['calendar_plans'] as Set<any>).map(IRenewalPlanLiteDtoToJSON)),
        'non_calendar_plans': value['non_calendar_plans'] == null ? undefined : (Array.from(value['non_calendar_plans'] as Set<any>).map(IRenewalPlanLiteDtoToJSON)),
        'calendar_payroll_groups': value['calendar_payroll_groups'] == null ? undefined : (Array.from(value['calendar_payroll_groups'] as Set<any>).map(IRenewalPayrollGroupReducedDtoToJSON)),
        'non_calendar_payroll_groups': value['non_calendar_payroll_groups'] == null ? undefined : (Array.from(value['non_calendar_payroll_groups'] as Set<any>).map(IRenewalPayrollGroupReducedDtoToJSON)),
    };
}

